import React, { useEffect, useState, Fragment, useMemo } from 'react';
import { notification, Badge, Drawer, Tabs } from 'antd';
import {
  MessageOutlined,
  SoundOutlined,
  ProfileOutlined,
  CloudDownloadOutlined,
  MailOutlined,
} from '@ant-design/icons';
import { connect } from 'dva';
import { adminMessageNumApi } from '@service';
import GeneralTabs from '../general-tabs';
import './index.less';
import Content from './dom';
import { socketDomain } from '@untils/socket-domain';

const { TabPane } = Tabs;

const mapStateToProps = state => ({
  user: state.userInfo.user,
});

const MessageList = ({ user }) => {
  const [msgData, setMsgData] = useState([
    // { content: '消息一：我就提醒你一下', time: '17:30' },
    // { content: '消息一：我就提醒你一下', time: '12:30' },
    // { content: '消息一：我就提醒你一下', time: '09:30' },
    // { content: '消息一：我就提醒你一下', time: '昨天' },
    // { content: '消息一：我就提醒你一下', time: '一个月前' },
  ]);
  const [taskData, setTaskData] = useState([
    // { content: '任务五：完善商品库存', url: '/abcss', time: '17:30' },
    // { content: '任务四：完善商品图片', url: '/abcss', time: '12:30' },
    // { content: '任务三：完善商品规格', url: '/abcss', time: '09:30' },
    // { content: '任务二：添加用户', url: '/abcss', time: '昨天' },
    // { content: '任务一：下架指定商品', url: '/abcss', time: '一个月前' },
  ]);
  const [fileData, setFileData] = useState([
    // { content: '下载任务一：商品数据.txt', url: '/abcss', time: '17:30' },
    // { content: '下载任务二：会员数据.word', url: '/abcss', time: '12:30' },
    // { content: '下载任务三：评论数据.xls', url: '/abcss', time: '09:30' },
    // { content: '下载任务四：会员照片.png', url: '/abcss', time: '昨天' },
    // { content: '下载任务五：商品视频.mp4', url: '/abcss', time: '一个月前' },
  ]);
  const [visible, setVisible] = useState(0);
  const [totalNum, setTotalNum] = useState(0);
  const [msgNum, setMsgNum] = useState(0);
  const [taskNum, setTaskNum] = useState(0);
  const [fileNum, setFileNum] = useState(0);
  let offLine = 1;
  let id = null;
  let webSocket = null;

  const openNotification = props => {
    let icon = <MailOutlined style={{ color: '#108ee9', lineHeight: '48px' }} />;
    let message = '您有新的消息哦！';

    switch (props.type) {
      case '0':
        icon = <SoundOutlined style={{ color: '#108ee9', lineHeight: '48px' }} />;
        break;
      case '1':
        message = '您有新的任务需要处理哦~';
        icon = <ProfileOutlined style={{ color: '#108ee9', lineHeight: '48px' }} />;
        break;
      case '2':
        message = '您有新的文件可以下载啦~';
        icon = <CloudDownloadOutlined style={{ color: '#108ee9', lineHeight: '48px' }} />;
        break;
    }
    notification.open({
      message: message,
      description: props.data.content,
      icon: icon,
      duration: 3,
    });
  };

  // const cutLength = (arr) => {
  //   if(arr.length > 5){
  //     arr.pop();
  //   }
  //   return arr
  // }
  const startWebSocket = () => {
    const mode = process.env.NODE_ENV;
    let wsServer = socketDomain[mode] + '?id=' + user.id;

    console.log(socketDomain[mode]);
    //let wsServer = 'ws://127.0.0.1:9502?id=' + user.id;
    let heartInterval;

    webSocket = new WebSocket(wsServer);

    webSocket.onopen = function () {
      console.log('Connected to WebSocket server.');
      offLine = 0;
      // 心跳
      heartInterval = setInterval(function () {
        offLine === 0 && webSocket.send('ping');
      }, 10000);
    };

    webSocket.onclose = function () {
      console.log('Disconnected');
      webSocket = null;
      offLine = 1;
      clearInterval(heartInterval);
      reConnect();
    };

    webSocket.onmessage = function (evt) {
      let result = JSON.parse(evt.data);
      let content = result.data.content;

      console.log(result);
      console.log('Retrieved data from server: ' + content);
      openNotification(result);
      switch (result.type) {
        case 0:
          setMsgData([result.data]);
          break;
        case 1:
          setTaskData([result.data]);
          break;
        case 2:
          setFileData([result.data]);
          break;
      }
    };

    webSocket.onerror = function (evt, e) {
      console.log(evt);
      console.log(String('Error occured: ') + e);
    };
  };
  /*eslint no-use-before-define: 0*/
  /*eslint-env es6*/
  const reConnect = () => {
    if (offLine && !id) {
      id = setInterval(function () {
        if (offLine) {
          startWebSocket();
        } else {
          clearInterval(id);
          id = null;
        }
      }, 3000);
    }
  };

  const getMessageNum = async () => {
    const { flag, data } = await adminMessageNumApi();

    if (flag === 200) {
      setTotalNum(data[0] + data[1] + data[2]);
      setMsgNum(data[0]);
      setTaskNum(data[1]);
      setFileNum(data[2]);
    }
  };

  useEffect(() => {
    console.log(process.env.NODE_ENV);
    // getAdminMessage(0);
    // getAdminMessage(1);
    // getAdminMessage(2);
    getMessageNum();

    startWebSocket();
  }, []);

  const onShow = () => {
    getMessageNum();
    setVisible(1);
  };

  const onClose = () => {
    setVisible(0);
  };

  const tabMsg = useMemo(() => {
    return (
      <span>
        <SoundOutlined />
        文本消息
        <Badge count={msgNum} className="total-badge site-badge-count-4" />
      </span>
    );
  }, [msgNum]);

  const tabTask = useMemo(() => {
    return (
      <span>
        <ProfileOutlined />
        任务通知
        <Badge count={taskNum} className="total-badge site-badge-count-4" />
      </span>
    );
  }, [taskNum]);

  const tabFile = useMemo(() => {
    return (
      <span>
        <CloudDownloadOutlined />
        文件导出
        <Badge count={fileNum} className="total-badge site-badge-count-4" />
      </span>
    );
  }, [fileNum]);

  return (
    <Fragment>
      <a onClick={onShow} className="top-message-text">
        <MessageOutlined />
        消息提醒
        <Badge count={totalNum} className="total-badge site-badge-count-4" />
      </a>
      <Drawer
        width={550}
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible}
        bodyStyle={{ overflowY: 'hidden' }}
      >
        <GeneralTabs>
          <TabPane tab={tabMsg} key="1">
            <Content type={0} newData={msgData} />
          </TabPane>
          <TabPane tab={tabTask} key="2">
            <Content type={1} newData={taskData} />
          </TabPane>
          <TabPane tab={tabFile} key="3" num={fileNum}>
            <Content type={2} newData={fileData} />
          </TabPane>
        </GeneralTabs>
      </Drawer>
    </Fragment>
  );
};

export default connect(mapStateToProps)(MessageList);
